import React from 'react'

const D_B = () => {
    return (
        <div className='container'>
            <h1>Program for Decimal to Binary Conversion</h1>
            <p>Given a decimal number as input, we need to write a program to convert
                 the given decimal number into equivalent binary number.</p>
                 <p><strong>Examples: </strong></p>
                 <div className='output'>
                 Input : 7 <br />
Output : 111 <br /> <br />

Input : 10 <br /> 
Output : 1010 <br />
                 </div>
                 <p><strong>Algorithm: </strong></p>
                 <ol>
                     <li>Store the remainder when the number is divided by 2 in an array.</li>
                     <li>Divide the number by 2</li>
                     <li>Repeat the above two steps until the number is greater than zero.</li>
                     <li>Print the array in reverse order now.</li>
                </ol>
                <p>For Example:&nbsp;<br/>
                If the binary number is 10.&nbsp; <br />
                <strong>Step 1</strong>: Remainder when 10 is divided by 2 is zero. Therefore, arr[0] = 0.&nbsp; <br />
                <strong>Step 2</strong>: Divide 10 by 2. New number is 10/2 = 5.&nbsp; <br />
                <strong>Step 3</strong>: Remainder when 5 is divided by 2 is 1. Therefore, arr[1] = 1.&nbsp; <br />
                <strong>Step 4</strong>: Divide 5 by 2. New number is 5/2 = 2.&nbsp; <br />
                <strong>Step 5</strong>: Remainder when 2 is divided by 2 is zero. Therefore, arr[2] = 0.&nbsp; <br />
                <strong>Step 6</strong>: Divide 2 by 2. New number is 2/2 = 1.&nbsp; <br />
                <strong>Step 7</strong>: Remainder when 1 is divided by 2 is 1. Therefore, arr[3] = 1.&nbsp; <br />
                <strong>Step 8</strong>: Divide 1 by 2. New number is 1/2 = 0.&nbsp; <br />
                <strong>Step 9</strong>: Since number becomes = 0. Print the array in reverse order. Therefore the equivalent binary number is 1010. <br />
                </p>
                <div class="containers">
    <div class="line number1 index0 alt2"><code class="comment">// Program to convert a decimal</code></div> 
    <div class="line number2 index1 alt1"><code class="comment">// number to binary number</code></div> 
    <div class="line number4 index3 alt1"><code class="library">#include &lt;iostream&gt;</code></div> <br/>
    <div class="line number5 index4 alt2"><code class="keywords">using</code> <code
            class="keywords">namespace</code> <code class="plain">std;</code></div> <br/>
    <div class="line number7 index6 alt2"><code class="comment">// function to convert decimal to binary</code></div> <br/>
    <div class="line number8 index7 alt1"><code class="keywords">void</code> <code
            class="plain">decToBinary(</code><code class="color1 bold">int</code> <code class="plain">n)</code></div> <br/>
    <div class="line number9 index8 alt2"><code class="plain">&#123;</code></div> <br/>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment">// array to store binary number</code></div> <br/>
    <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">binaryNum[32];</code></div> <br/>

    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment">// counter for binary array</code></div> <br/>
    <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">i = 0;</code></div> <br/>
    <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">while</code> <code class="plain">(n &gt; 0) &#123;</code></div> <br/>
    <div class="line number17 index16 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment">// storing remainder in binary array</code></div> <br/>
    <div class="line number18 index17 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">binaryNum[i] = n % 2;</code></div> <br/>
    <div class="line number19 index18 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">n = n / 2;</code></div> <br/>
    <div class="line number20 index19 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">i++;</code></div> <br/>
    <div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div> <br/>
    <div class="line number22 index21 alt1">&nbsp;</div> <br/>
    <div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment">// printing binary array in reverse order</code></div> <br/>
    <div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">for</code> <code class="plain">(</code><code class="color1 bold">int</code> <code
            class="plain">j = i - 1; j &gt;= 0; j--)</code></div> <br/>
    <div class="line number25 index24 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; binaryNum[j];</code></div> <br/>
    <div class="line number26 index25 alt1"><code class="plain">&#125;</code></div> <br/>
    <div class="line number27 index26 alt2">&nbsp;</div> <br/>
    <div class="line number29 index28 alt2"><code class="color1 bold">int</code> <code class="plain">main()</code></div> <br/>
    <div class="line number30 index29 alt1"><code class="plain">&#123;</code></div> <br/>
    <div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">n = 17;</code></div> <br/>
    <div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">decToBinary(n);</code></div> <br/>
    <div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">return</code> <code class="plain">0;</code></div> <br/>
    <div class="line number34 index33 alt1"><code class="plain">&#125;</code></div> <br/>
</div> <br/>
<div className='output'>
    <p><strong>Output:</strong></p>
10001
</div>
        </div>
    )
}

export default D_B
